import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_SCREENSHARE_CAPTURE_FRAME_RATE, SET_SCREENSHARE_TRACKS, SET_SCREEN_AUDIO_SHARE_STATE } from './actionTypes';
/**
 * Reduces the Redux actions of the feature features/screen-share.
 */
ReducerRegistry.register('features/screen-share', (state = {}, action) => {
    const { captureFrameRate, isSharingAudio, desktopAudioTrack } = action;
    switch (action.type) {
        case SET_SCREEN_AUDIO_SHARE_STATE:
            return Object.assign(Object.assign({}, state), { isSharingAudio });
        case SET_SCREENSHARE_CAPTURE_FRAME_RATE:
            return Object.assign(Object.assign({}, state), { captureFrameRate });
        case SET_SCREENSHARE_TRACKS:
            return Object.assign(Object.assign({}, state), { desktopAudioTrack });
        default:
            return state;
    }
});
